
import store from '@store'
export default function load ({ loadFunc, loadModel }) {
  if (loadModel) {
    loadModel().then(v => {
      let model = v.default
      store.registerModule(model.namespace, { ...model, namespaced: true })
    })
  }
  return () => ({
    component: loadFunc()
  })
}
